import React, { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import { Close, ChevronLeft, ChevronRight } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    background: "rgba(0,0,0,0.92)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  closeBtn: {
    position: "absolute",
    top: 16,
    right: 16,
    color: "#fff",
    zIndex: 10000,
  },
  mainImage: {
    maxWidth: "85vw",
    maxHeight: "75vh",
    objectFit: "contain",
  },
  mainVideo: {
    maxWidth: "85vw",
    maxHeight: "75vh",
  },
  navBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#fff",
    background: "rgba(255,255,255,0.1)",
    "&:hover": { background: "rgba(255,255,255,0.2)" },
  },
  navLeft: { left: 16 },
  navRight: { right: 16 },
  thumbnails: {
    display: "flex",
    gap: 8,
    marginTop: 16,
    overflowX: "auto",
    padding: "8px 16px",
    maxWidth: "90vw",
  },
  thumb: {
    width: 60,
    height: 60,
    minWidth: 60,
    objectFit: "cover",
    borderRadius: 4,
    cursor: "pointer",
    opacity: 0.5,
    transition: "opacity 0.2s, border-color 0.2s",
    border: "2px solid transparent",
  },
  thumbActive: {
    opacity: 1,
    borderColor: "#fff",
  },
  counter: {
    position: "absolute",
    bottom: 100,
    color: "rgba(255,255,255,0.7)",
    fontSize: 14,
  },
}));

const MediaGallery = ({ messages, initialIndex = 0, onClose }) => {
  const classes = useStyles();
  const [current, setCurrent] = useState(initialIndex);

  const goNext = useCallback(() => {
    setCurrent((prev) => (prev + 1) % messages.length);
  }, [messages.length]);

  const goPrev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + messages.length) % messages.length);
  }, [messages.length]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") goNext();
      if (e.key === "ArrowLeft") goPrev();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose, goNext, goPrev]);

  const msg = messages[current];
  if (!msg) return null;

  const isVideo = msg.mediaType === "video";

  return (
    <div className={classes.overlay} onClick={onClose}>
      <IconButton className={classes.closeBtn} onClick={onClose}>
        <Close fontSize="large" />
      </IconButton>

      {messages.length > 1 && (
        <>
          <IconButton
            className={`${classes.navBtn} ${classes.navLeft}`}
            onClick={(e) => {
              e.stopPropagation();
              goPrev();
            }}
          >
            <ChevronLeft fontSize="large" />
          </IconButton>
          <IconButton
            className={`${classes.navBtn} ${classes.navRight}`}
            onClick={(e) => {
              e.stopPropagation();
              goNext();
            }}
          >
            <ChevronRight fontSize="large" />
          </IconButton>
        </>
      )}

      <div onClick={(e) => e.stopPropagation()}>
        {isVideo ? (
          <video
            key={msg.id}
            className={classes.mainVideo}
            src={msg.mediaUrl}
            controls
            autoPlay
          />
        ) : (
          <img
            key={msg.id}
            className={classes.mainImage}
            src={msg.mediaUrl}
            alt=""
          />
        )}
      </div>

      {messages.length > 1 && (
        <>
          <div className={classes.counter}>
            {current + 1} / {messages.length}
          </div>
          <div
            className={classes.thumbnails}
            onClick={(e) => e.stopPropagation()}
          >
            {messages.map((m, i) => (
              <img
                key={m.id}
                src={m.mediaUrl}
                alt=""
                className={`${classes.thumb} ${
                  i === current ? classes.thumbActive : ""
                }`}
                onClick={() => setCurrent(i)}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MediaGallery;
